import { useEffect, useState } from "react";
import Lenis from "lenis";
import { api } from "@/lib/api";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { VideosSection } from "@/components/VideosSection";
import { ProductsSection } from "@/components/ProductsSection";
import { ScienceSection } from "@/components/ScienceSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { FaqSection } from "@/components/FaqSection";
import { Footer } from "@/components/Footer";

const FALLBACK = {
  businessName: "365 Cellular Energy",
  logoUrl: "/assets/logo.jpg",
  whatsapp: "18453750886",
  whatsappDisplay: "+1 (845) 375-0886",
  heroBadge: "Biotecnología & Salud Celular",
  heroLine1: "ENERGÍA",
  heroLine2: "CELULAR",
  heroLine3: "365",
  heroSubtitle: "Suplementos alimenticios premium.",
  stats: [],
  marqueeItems: [],
  videos: [],
  chapters: [],
  testimonials: [],
  faqs: [],
};

export default function LandingPage() {
  const [content, setContent] = useState(FALLBACK);
  const [products, setProducts] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (t) => { lenis.raf(t); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); };
  }, []);

  useEffect(() => {
    Promise.all([api.get("/content"), api.get("/products")])
      .then(([c, p]) => {
        setContent({ ...FALLBACK, ...c.data });
        setProducts(p.data);
        if (c.data.businessName) document.title = `${c.data.businessName} | Suplementos de Energía Celular Premium`;
      })
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  if (!ready) {
    return (
      <div className="min-h-screen bg-[#050806] flex items-center justify-center" data-testid="landing-loading">
        <img src="/assets/logo.jpg" alt="365 Cellular Energy" className="w-24 h-24 rounded-full animate-pulse glow-emerald" />
      </div>
    );
  }

  return (
    <div className="bg-[#050806] text-white min-h-screen" data-testid="landing-page">
      <Header content={content} />
      <main>
        <Hero content={content} />
        <Marquee items={content.marqueeItems} />
        <VideosSection videos={content.videos} />
        <ProductsSection products={products} content={content} />
        <ScienceSection chapters={content.chapters} />
        <TestimonialsSection testimonials={content.testimonials} />
        <FaqSection faqs={content.faqs} content={content} />
      </main>
      <Footer content={content} />
    </div>
  );
}
